import { render, staticRenderFns } from "./guias_remision_list.vue?vue&type=template&id=08e80666"
import script from "./guias_remision_list.vue?vue&type=script&lang=js"
export * from "./guias_remision_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports